module.exports = __webpack_public_path__ + "static/media/manhattan-light-red-cord.0def9085.jpg";